export const languagesOptions = ["English", "Hebrew"];

export const languagesMapper = {
  Hebrew: "he",
  English: "en",
};
